import React from 'react';
import { View } from '@uncinc/react-drupal-core';

const MemberStoriesOverviewParagraph = ({ entity }) => {
  const title = entity.getIn(['field_title', 0, 'value']);
  const ctaUrl = entity.getIn(['field_link', 0, 'alias']) || entity.getIn(['field_link', 0, 'uri']);
  const ctaTitle = entity.getIn(['field_link', 0, 'title']);
  const image = entity.get('field_media');
  const paragraphId = entity.getIn(['id', 0, 'value']);
  const paragraphKey = `paragraph:${paragraphId}`;

  return (
    <div id={paragraphKey} className="Paragraph MemberStoriesOverviewParagraph">
      <View id="member_stories" display="block_1" title={title} ctaUrl={ctaUrl} ctaTitle={ctaTitle} image={image} />
    </div>
  );
};

export default MemberStoriesOverviewParagraph;

